import * as types from './mutation-types'

export const setUser = ({commit}, userRecord) => {
  if (userRecord) {
    commit(types.SET_USER, userRecord)
  }
}

export const setStyles = ({commit}, styles) => {
  if (styles) {
    commit(types.SET_STYLES, styles)
  }
}

export const setAppState = ({commit}, appState) => {
  if (appState) {
    commit(types.SET_APP_STATE, appState)
  }
}

export const setLoggingIn = ({commit}, loggingIn) => {
  commit(types.SET_CS_LOGGING_IN, loggingIn)
}

export const setSessionExpired = ({commit}, expired) => {
  commit(types.SET_CS_SESSION_EXPIRED, expired)
}

export const buildNavItems = ({commit}, vueContext) => {
  if (vueContext) {
    commit(types.BUILD_NAV_ITEMS, vueContext)
  }
}

export const buildMenu = ({commit}, vueContext) => {
  if (vueContext) {
    commit(types.BUILD_MENU, vueContext)
  } else {
    console.error('No context', vueContext)
  }
}

export const updateNavItems = ({commit}, vueContext) => {
  if (vueContext) {
    commit(types.UPDATE_NAV_ITEMS, vueContext)
  }
}

export const setClubSettings = ({commit}, settings) => {
  if (settings) {
    commit(types.SET_CLUB_SETTINGS, settings)
  }
}

export const setAppConfig = ({commit}, config) => {
  if (config) {
    commit(types.SET_APP_CONFIG, config)
  }
}

export const setClubSettingsCacheKey = ({commit}, req) => {
  commit(types.SET_CS_CACHE_KEY, req)
}

export const requestClubSettingsRefresh = ({commit}, req) => {
  commit(types.SET_CS_RELOAD_REQ, req)
}
